import { createMuiTheme } from '@material-ui/core/styles';
import Colors from './Colors';

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      light: Colors.redHighlight,
      main: Colors.redPrimary,
      dark: Colors.redLowlight,
      contrastText: Colors.white
    },
    paper: Colors.background,
    default: Colors.background
  }
});

export default theme;